import React, { Component, Fragment } from "react";
import productPic from "../../assets/images/no-product-image.png";
import { UtilityService , FileUploadService } from "../../services";

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Field from "../../components/Common/Field/Field";
import Button from '../../components/Buttons/Button'

//redux
import { connect } from "react-redux";
import * as mainAction from "../../redux/action/main";
import { bindActionCreators } from "redux";

class Profile extends Component {

  state = {
    userData: {
        firstName : '',
        lastName : '',
        profilePicture : '',
        rememberMe : false,
    },
    changePassword: false,
    disabled : false,
  }

  componentWillMount = () => {
    let { firstName, lastName , profilePicture } = this.props.userDetails
    let userData = {...this.state.userData}
    userData.firstName = firstName
    userData.lastName =  lastName
    userData.profilePicture = profilePicture
    this.setState({ userData })
  }

  updateProfile = () => {
    UtilityService.updateProfile(this.state.userData)
      .then(response => {
        if (response.status === 200) {
          let userDetails = {
            firstName : response.text.data.firstName ,
            lastName : response.text.data.lastName,
            userId: "",
            authToken: localStorage.getItem("authToken"),
            profilePicture: response.text.data.profilePicture,
            rememberMe: response.text.data.rememberMe,
            isLoggedIn: true
          };
          this.props.actions.updateBasicDetails(userDetails);
          this.props.getalertMessage("success", " Profile Updated");
          this.props.history.push("/");
        }
        response.status == 401 && this.props.unauthorisedFunc();
      })
      .catch(error => {
        this.props.getalertMessage("error", error);
      });
  }

  updateInfo = (name,value) => {
    let userData = { ...this.state.userData };
     userData[name] = value
    this.setState({ userData });
  };

  updateProfilePicture = (files) =>{
    FileUploadService.uploadFile(files[0],'profile')
    .then(response => {
      if (response.status === 200) {
        let userData = { ...this.state.userData };
        userData.profilePicture = response.text.data.url
        this.setState({
          userData
        });
        this.props.getalertMessage("success", " Image Updated");
      } else if (response.status === 401) {
        this.props.unauthorisedFunc();
      } else {
        this.props.getalertMessage("error", " Something went wrong ");
      }
    })
    .catch(error => {
      this.props.getalertMessage("error", error);
    });
  }

  updateChangePassword = (name, value) => {
    this.setState({
      [name]: value
    });
  }

  render() {

    const { userData } = this.state
    
      return (
        <Fragment>
          <div class="right-section">
            <div class="row nopadding bg-white full-width">
              <PageHeader 
                history = {this.props.history}
                header="Profile" 
              />
              <div class="col-md-12 nopadding">
                <div class="col-md-8 col-md-offset-2">
                <div className="col-md-12 br-col">
                  <div class="col-md-12 nopadding">
                    <div class="col-md-6">
                      <Field
                        isFormGroup={true}
                        inputType="text"
                        inputName="firstName"
                        value={userData.firstName}
                        label ={"First Name"}
                        onChange={this.updateInfo}
                        disabled={this.state.disabled}
                       />
                    </div>
                    <div class="col-md-6">
                      <Field
                        isFormGroup={true}
                        inputType="text"
                        inputName="lastName"
                        value={userData.lastName}
                        label ={"Last Name"}
                        onChange={this.updateInfo}
                        disabled={this.state.disabled}
                       />
                    </div>
                    </div>
                    <div className="col-md-12 nopadding mt-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="ref-no">
                          Do You Want to Change Password ?
                        </label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <Field
                          inputType="checkboxToggle"
                          inputName="changePassword"
                          value={this.state.changePassword}
                          onChange={this.updateChangePassword}
                        />
                      </div>
                    </div>
                    </div>
                    {this.state.changePassword && (
                      <Fragment>
                        <div class="col-md-6">
                          <Field
                                isFormGroup={true}
                                inputType="password"
                                inputName="password"
                                value={userData.password}
                                label ={"New Password"}
                                onChange={this.updateInfo}
                                disabled={this.state.disabled}
                            />
                        </div>
                        <div class="col-md-6">
                          <Field
                                isFormGroup={true}
                                inputType="password"
                                inputName="changePassword"
                                value={userData.changePassword}
                                label ={"Confirm Password"}
                                onChange={this.updateInfo}
                                disabled={this.state.disabled}
                            />
                        </div>
                      </Fragment>
                    )}
                    <div class="col-md-12 nopadding">
                      <div class="col-md-6">
                          <label for="Address">Upload Profile Photo</label>
                      </div>
                      <div className="col-md-6">
                      <div class="upload-photo">
                            <img
                              src={userData.profilePicture != ''?
                                UtilityService.fileUrl()+
                                userData.profilePicture : productPic
                              }
                              id="uploadCAD"
                              name="profilePicture"
                              alt={this.state.userData.profilePicture}
                            />
                          <a
                            class="btn-floating btn-small waves-effect waves-light black btn-img-upload"
                          >
                            <i class="material-icons input-file-i">add</i>
                          </a>
                          <input
                            type="file"
                            accept="image/*"
                            className="input-file"
                            name="profilePicture"
                            style={{ display: "none" }}
                            onChange={e => this.updateProfilePicture(e.target.files)}
                          />
                        </div>
                      </div>
                    </div>
                  <div class="col-md-12 profile-btn text-center">
                    <Button 
                        buttonType = "save"
                        buttonName = "Update"
                        onClick ={this.updateProfile}
                    />
                    <Button 
                        buttonType = "cancel"
                        buttonName = "cancel"
                        history = {this.props.history}
                    />
                  </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
        </Fragment>
      );
  }
}

const mapStateToProps = state => {
  return {
    userDetails: state.main
  };
};
const mapDispatchToProps = dispatch => {
  return { actions: bindActionCreators(mainAction, dispatch) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);


// WEBPACK FOOTER //
// ./src/pages/Profile/page.js